import { useQuery } from '@hooks/reactQuery';

import { getConsistencyCheckHistoryConsistencyStatuses } from '@api/consistencyCheckParameters';

import { mapDropdownOptions } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { CONSISTENCY_CHECK_HISTORY_CONSISTENCY_STATUSES } from '@constants/queryKeys';

interface IUseConsistencyCheckHistoryConsistencyStatuses {
	consistencyCheckConsistencyStatuses: TSelectOption<string>[];
	isLoadingConsistencyCheckConsistencyStatuses: boolean;
}

const useConsistencyCheckHistoryConsistencyStatuses = (): IUseConsistencyCheckHistoryConsistencyStatuses => {
	const {
		data,
		isInitialLoading,
		isFetching,
	} = useQuery({
		queryKey: [CONSISTENCY_CHECK_HISTORY_CONSISTENCY_STATUSES],
		queryFn: getConsistencyCheckHistoryConsistencyStatuses,
		select: (data) => mapDropdownOptions({
			items: data,
			valueKey: 'name',
			labelKey: 'title',
		}),
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleViewer,
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		...refetchOptions,
	});

	return {
		consistencyCheckConsistencyStatuses: data || [],
		isLoadingConsistencyCheckConsistencyStatuses: isInitialLoading || isFetching,
	};
};

export default useConsistencyCheckHistoryConsistencyStatuses;
